// src/router/trie-router/index.ts
import { TrieRouter } from "./router.js";
export {
  TrieRouter
};
